var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-2 items-center"},[_c('b-form-input',{attrs:{"value":_vm.value,"size":"sm","autocomplete":"off"},on:{"input":_vm.input}}),_c('plus-button',{attrs:{"value":_vm.value,"max":_vm.max},on:{"input":_vm.input}}),_c('minus-button',{attrs:{"value":_vm.value,"min":_vm.min},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }